"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var TZ = "Europe/Paris";
  var DEFAULT_COLOR = "#bccad6";
  var DAY_NAMES = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];
  var MONTH_NAMES = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

  var stripId = function stripId(id) {
    return (id || "").replace(/^\$/, "");
  };
  // Les jours sont calculés sur des dates texte pour ne pas être décalés par les changements d'heure.
  var shiftDate = function shiftDate(date, days) {
    return moment(date, "YYYY-MM-DD").add(days, "day").format("YYYY-MM-DD");
  };
  var dayStart = function dayStart(date) {
    return moment.tz(date, "YYYY-MM-DD", TZ).toDate();
  };
  var todayDate = function todayDate() {
    return moment().tz(TZ).format("YYYY-MM-DD");
  };
  var mondayOf = function mondayOf(date) {
    var day = moment(date, "YYYY-MM-DD");
    return day.subtract((day.day() + 6) % 7, "day").format("YYYY-MM-DD");
  };
  var currentMonday = function currentMonday() {
    return mondayOf(todayDate());
  };
  var monthOf = function monthOf(date) {
    return moment(date, "YYYY-MM-DD").startOf("month").format("YYYY-MM-DD");
  };

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $timeout, ModalService, OperatorsService, SchedulesService, PlanningCells) {
      _classCallCheck(this, Controller);

      this.$timeout = $timeout;
      this.ModalService = ModalService;
      this.OperatorsService = OperatorsService;
      this.SchedulesService = SchedulesService;
      this.PlanningCells = PlanningCells;

      this.isSuper = ["super-admin", "super-operator"].indexOf($rootScope.$user.role) > -1;
      this.weekStart = currentMonday();
      // La vue mois n'est proposée que pour un seul conseiller.
      this.mode = "week";
      this.monthStart = monthOf(todayDate());
      this.weeks = [];
      this.operators = [];
      this.schedules = [];
      this.closuresByOperator = {};
      this.rows = [];
      this.days = [];
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.reload();

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()

      // Recharge conseillers, plages et fermetures (ouverture du planning ou bouton Recharger de la page).

    }, {
      key: "reload",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this = this;

          var results;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!this.reloading) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return");

                case 2:
                  this.reloading = true;
                  _context2.prev = 3;
                  _context2.next = 6;
                  return Promise.all([this.OperatorsService.get(), this.SchedulesService.load(null, false, null, null)]);

                case 6:
                  results = _context2.sent;

                  this.schedules = results[1] || [];
                  this.operators = (results[0] || []).sort(function (a, b) {
                    return _this.operatorName(a).localeCompare(_this.operatorName(b));
                  });
                  _context2.next = 15;
                  break;

                case 11:
                  _context2.prev = 11;
                  _context2.t0 = _context2["catch"](3);

                  console.error(_context2.t0);
                  Notiflix.Notify.failure("Impossible de charger les horaires des conseillers.");

                case 15:
                  _context2.next = 17;
                  return this.loadClosures();

                case 17:
                  this.reloading = false;

                case 18:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[3, 11]]);
        }));

        function reload() {
          return _ref2.apply(this, arguments);
        }

        return reload;
      }()
    }, {
      key: "$onChanges",
      value: function $onChanges(changes) {
        if (changes.reloadToken && !changes.reloadToken.isFirstChange()) this.reload();
        if (!changes.operatorId || changes.operatorId.isFirstChange()) return;
        if (!this.operatorId && this.mode === "month") {
          this.setMode("week");
        } else {
          this.build();
        }
      }
    }, {
      key: "isMonthView",
      value: function isMonthView() {
        return this.mode === "month" && !!this.operatorId;
      }

      // Garde la période affichée en passant d'une vue à l'autre.

    }, {
      key: "setMode",
      value: function setMode(mode) {
        if (mode === this.mode) return;
        if (mode === "month") {
          this.monthStart = monthOf(this.weekStart === currentMonday() ? todayDate() : this.weekStart);
        } else {
          var today = todayDate();
          this.weekStart = monthOf(today) === this.monthStart ? currentMonday() : mondayOf(this.monthStart);
        }
        this.mode = mode;
        this.loadClosures();
      }

      // Premier jour affiché : lundi de la semaine, ou lundi de la semaine du 1er du mois.

    }, {
      key: "rangeStart",
      value: function rangeStart() {
        return this.isMonthView() ? mondayOf(this.monthStart) : this.weekStart;
      }
    }, {
      key: "reloadSchedules",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return this.SchedulesService.load(null, false, null, null);

                case 3:
                  _context3.t0 = _context3.sent;

                  if (_context3.t0) {
                    _context3.next = 6;
                    break;
                  }

                  _context3.t0 = [];

                case 6:
                  this.schedules = _context3.t0;
                  _context3.next = 13;
                  break;

                case 9:
                  _context3.prev = 9;
                  _context3.t1 = _context3["catch"](0);

                  console.error(_context3.t1);
                  Notiflix.Notify.failure("Impossible de recharger les horaires des conseillers.");

                case 13:
                  this.build();

                case 14:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[0, 9]]);
        }));

        function reloadSchedules() {
          return _ref3.apply(this, arguments);
        }

        return reloadSchedules;
      }()
    }, {
      key: "operatorName",
      value: function operatorName(operator) {
        return ((operator.firstName || "") + " " + (operator.lastName || "")).trim();
      }
    }, {
      key: "initials",
      value: function initials(operator) {
        return (operator.firstName || "").charAt(0) + (operator.lastName || "").charAt(0);
      }
    }, {
      key: "color",
      value: function color(operator) {
        return operator.calendarColor || DEFAULT_COLOR;
      }
    }, {
      key: "hour",
      value: function hour(date) {
        return moment(date).tz(TZ).format("HH:mm");
      }
    }, {
      key: "loadClosures",
      value: function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
          var rangeStart, slots;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  rangeStart = this.rangeStart();
                  _context4.prev = 1;
                  _context4.next = 4;
                  return this.SchedulesService.post("mobile/bookedSlots", { start: dayStart(rangeStart) });

                case 4:
                  _context4.t0 = _context4.sent;

                  if (_context4.t0) {
                    _context4.next = 7;
                    break;
                  }

                  _context4.t0 = [];

                case 7:
                  slots = _context4.t0;

                  if (!(rangeStart !== this.rangeStart())) {
                    _context4.next = 10;
                    break;
                  }

                  return _context4.abrupt("return");

                case 10:
                  this.closuresByOperator = this.PlanningCells.closuresByOperator(slots);
                  _context4.next = 17;
                  break;

                case 13:
                  _context4.prev = 13;
                  _context4.t1 = _context4["catch"](1);

                  console.error(_context4.t1);
                  Notiflix.Notify.failure("Impossible de charger les fermetures de la période.");

                case 17:
                  this.build();

                case 18:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this, [[1, 13]]);
        }));

        function loadClosures() {
          return _ref4.apply(this, arguments);
        }

        return loadClosures;
      }()

      // Avance ou recule d'une semaine ou d'un mois selon la vue.

    }, {
      key: "shift",
      value: function shift(direction) {
        if (this.isMonthView()) {
          this.monthStart = moment(this.monthStart, "YYYY-MM-DD").add(direction, "month").format("YYYY-MM-DD");
        } else {
          this.weekStart = shiftDate(this.weekStart, 7 * direction);
        }
        this.loadClosures();
      }
    }, {
      key: "previous",
      value: function previous() {
        this.shift(-1);
      }
    }, {
      key: "next",
      value: function next() {
        this.shift(1);
      }
    }, {
      key: "today",
      value: function today() {
        this.weekStart = currentMonday();
        this.monthStart = monthOf(todayDate());
        this.loadClosures();
      }
    }, {
      key: "periodLabel",
      value: function periodLabel() {
        if (this.isMonthView()) {
          var month = moment(this.monthStart, "YYYY-MM-DD");
          return MONTH_NAMES[month.month()] + " " + month.year();
        }
        return "Semaine du " + moment(this.weekStart, "YYYY-MM-DD").format("DD/MM") + " au " + moment(shiftDate(this.weekStart, 6), "YYYY-MM-DD").format("DD/MM/YYYY");
      }

      // Cases d'un conseiller pour une suite de jours consécutifs.

    }, {
      key: "operatorCells",
      value: function operatorCells(operator, days) {
        var _this2 = this;

        var operatorId = stripId(operator._id);
        var from = dayStart(days[0]);
        var to = dayStart(shiftDate(days[days.length - 1], 1));
        var occurrences = [];
        this.schedules.filter(function (schedule) {
          return stripId(schedule.userId) === operatorId;
        }).forEach(function (schedule) {
          occurrences = occurrences.concat(_this2.PlanningCells.getScheduleOccurrences(schedule, from, to));
        });
        var closures = this.closuresByOperator[operatorId] || [];
        return days.map(function (day) {
          return _this2.PlanningCells.buildDayCell(occurrences, closures, dayStart(day), dayStart(shiftDate(day, 1)));
        });
      }
    }, {
      key: "build",
      value: function build() {
        if (this.isMonthView()) {
          this.buildMonth();
        } else {
          this.buildWeek();
        }
      }

      // Calcule les cases de la semaine affichée, une ligne par conseiller.

    }, {
      key: "buildWeek",
      value: function buildWeek() {
        var _this3 = this;

        var weekDays = [0, 1, 2, 3, 4, 5, 6].map(function (index) {
          return shiftDate(_this3.weekStart, index);
        });

        // Le filtre conseiller de la page isole sa ligne.
        var operators = this.operatorId ? this.operators.filter(function (operator) {
          return stripId(operator._id) === stripId(_this3.operatorId);
        }) : this.operators;
        var rows = operators.map(function (operator) {
          return {
            operator: operator,
            cells: _this3.operatorCells(operator, weekDays)
          };
        });

        // Le week-end n'est affiché que si quelqu'un y travaille.
        var visible = weekDays.map(function (day, index) {
          return index;
        }).filter(function (index) {
          return index < 5 || rows.some(function (row) {
            return row.cells[index].work !== null;
          });
        });

        this.days = visible.map(function (index) {
          return {
            name: DAY_NAMES[index],
            label: moment(weekDays[index], "YYYY-MM-DD").format("DD/MM"),
            date: weekDays[index]
          };
        });
        this.rows = rows.map(function (row) {
          return {
            operator: row.operator,
            cells: visible.map(function (index) {
              return row.cells[index];
            })
          };
        });
        this.$timeout(function () {}, 0);
      }

      // Calcule le mois du conseiller filtré : une ligne par semaine, du lundi au dimanche.

    }, {
      key: "buildMonth",
      value: function buildMonth() {
        var _this4 = this;

        this.monthOperator = this.operators.find(function (operator) {
          return stripId(operator._id) === stripId(_this4.operatorId);
        });
        if (!this.monthOperator) {
          this.weeks = [];
          this.days = [];
          this.$timeout(function () {}, 0);
          return;
        }

        var gridStart = mondayOf(this.monthStart);
        var monthEnd = moment(this.monthStart, "YYYY-MM-DD").endOf("month").format("YYYY-MM-DD");
        var dates = [];
        for (var date = gridStart; date <= monthEnd || dates.length % 7; date = shiftDate(date, 1)) {
          dates.push(date);
        }
        var cells = this.operatorCells(this.monthOperator, dates);
        var month = this.monthStart.slice(0, 7);
        var today = todayDate();

        // Le week-end n'est affiché que si le conseiller y travaille dans le mois.
        var visible = [0, 1, 2, 3, 4, 5, 6].filter(function (index) {
          return index < 5 || dates.some(function (date, position) {
            return position % 7 === index && date.slice(0, 7) === month && cells[position].work;
          });
        });

        this.days = visible.map(function (index) {
          return { name: DAY_NAMES[index] };
        });
        this.weeks = [];
        for (var start = 0; start < dates.length; start += 7) {
          this.weeks.push(visible.map(function (index) {
            return {
              date: dates[start + index],
              label: moment(dates[start + index], "YYYY-MM-DD").format("DD/MM"),
              inMonth: dates[start + index].slice(0, 7) === month,
              isToday: dates[start + index] === today,
              cell: cells[start + index]
            };
          }));
        }
        this.$timeout(function () {}, 0);
      }

      // Ouvre le détail de la journée, puis la fenêtre choisie depuis ce détail.

    }, {
      key: "openDay",
      value: function openDay(operator, day) {
        var _this5 = this;

        if (!this.isSuper) return;
        var operatorId = stripId(operator._id);
        this.ModalService.openComponent("operator-day", {
          operator: operator,
          date: day.date,
          schedules: this.operatorSchedules(operator),
          closures: this.closuresByOperator[operatorId] || [],
          closuresFrom: this.rangeStart()
        }).then(function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(result) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (result) {
                      _context5.next = 2;
                      break;
                    }

                    return _context5.abrupt("return");

                  case 2:
                    if (!result.changed) {
                      _context5.next = 5;
                      break;
                    }

                    _context5.next = 5;
                    return Promise.all([_this5.loadClosures(), _this5.reloadSchedules()]);

                  case 5:
                    if (result.action === "createClosure") _this5.createClosure(operator, { date: result.date });
                    if (result.action === "editClosure") _this5.openClosure({ _id: result.id });
                    if (result.action === "editSchedules") _this5.editSchedules(operator);
                    if (result.action === "editSchedule") _this5.openSchedule({ _id: result.id });
                    if (result.action === "duplicateSchedule") _this5.openSchedule({ _id: result.id, duplicate: true });

                  case 10:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, _this5);
          }));

          return function (_x) {
            return _ref5.apply(this, arguments);
          };
        }()).catch(function (error) {
          return console.log(error);
        });
      }
    }, {
      key: "operatorSchedules",
      value: function operatorSchedules(operator) {
        var operatorId = stripId(operator._id);
        return this.schedules.filter(function (schedule) {
          return stripId(schedule.userId) === operatorId;
        });
      }

      // Ouvre la création d'une fermeture pré-remplie avec le conseiller et le jour.

    }, {
      key: "createClosure",
      value: function createClosure(operator, day) {
        if (!this.isSuper) return;
        this.openClosure({ _id: null, operatorId: "$" + stripId(operator._id), date: day.date });
      }
    }, {
      key: "editClosure",
      value: function editClosure(closure, $event) {
        $event.stopPropagation();
        if (!this.isSuper) return;
        this.openClosure({ _id: closure.id });
      }
    }, {
      key: "openClosure",
      value: function openClosure(params) {
        var _this6 = this;

        params.size = "lg";
        this.ModalService.openComponent("closed-slot", params).then(function () {
          return _this6.loadClosures();
        }).catch(function (error) {
          return console.log(error);
        });
      }

      // Ouvre le formulaire complet d'une plage, en modification ou en duplication.

    }, {
      key: "openSchedule",
      value: function openSchedule(params) {
        var _this7 = this;

        this.ModalService.open("schedules/schedule", params).then(function () {
          return _this7.reloadSchedules();
        }).catch(function (error) {
          return console.log(error);
        });
      }

      // Ouvre les horaires du conseiller ; le formulaire complet est ouvert ici pour pouvoir recharger ensuite.

    }, {
      key: "editSchedules",
      value: function editSchedules(operator) {
        var _this8 = this;

        if (!this.isSuper) return;
        this.ModalService.openComponent("operator-schedules", {
          size: "lg",
          operator: operator,
          schedules: this.operatorSchedules(operator)
        }).then(function (result) {
          if (result && result.fullFormId) {
            return _this8.ModalService.open("schedules/schedule", { _id: result.fullFormId });
          }
        }).then(function () {
          return _this8.reloadSchedules();
        }).catch(function (error) {
          return console.log(error);
        });
      }
    }]);

    return Controller;
  }();

  angular.module("schedules.planning").component("schedulesPlanning", {
    templateUrl: "app/pages/schedules/planning/planning.html",
    bindings: { operatorId: "<?", reloadToken: "<?" },
    controller: Controller
  });
})();